import { render, staticRenderFns } from "./HorseRace.vue?vue&type=template&id=f5d8943a&scoped=true&"
import script from "./HorseRace.vue?vue&type=script&lang=js&"
export * from "./HorseRace.vue?vue&type=script&lang=js&"
import style0 from "./HorseRace.vue?vue&type=style&index=0&id=f5d8943a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d8943a",
  null
  
)

export default component.exports